import { Component, ContentChild, Input } from '@angular/core';

@Component({
  selector: 'rt-dialog-toolbar',
  styleUrls: ['./dialog-toolbar.component.less'],
  template: `
    <div class="title">
      <ng-container *ngTemplateOutlet="title"></ng-container>
    </div>
    <div class="actions">
      <ng-container *ngTemplateOutlet="actions"></ng-container>
    </div>
  `,
  host: {
    '[class.active]': 'active',
  },
})
export class DialogToolbarComponent {
  @Input() public active: boolean;
  @ContentChild('title', /* TODO: add static flag */ { static: true }) public title: any;
  @ContentChild('actions', /* TODO: add static flag */ { static: true }) public actions: any;
}
